import { render, staticRenderFns } from "./facepayment.vue?vue&type=template&id=2c214489&scoped=true&"
import script from "./facepayment.vue?vue&type=script&lang=js&"
export * from "./facepayment.vue?vue&type=script&lang=js&"
import style0 from "./facepayment.vue?vue&type=style&index=0&id=2c214489&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c214489",
  null
  
)

export default component.exports